import "../../../assets/RideCheckbox.css";
import { RideErrorMessage as x } from "../error-message/RideErrorMessage.js";
import k from "clsx";
import t, { forwardRef as f, useRef as E, useImperativeHandle as N } from "react";
import { RideGlCheck as R } from "../graphic/glyph/components/RideGlCheck.js";
import { RideGlIndeterminate as g } from "../graphic/glyph/components/RideGlIndeterminate.js";
const C = "_checkbox_eet7y_14", v = "_input_eet7y_7", G = "_glyph_eet7y_46", z = "_error_eet7y_81", I = "_disabled_eet7y_87", w = "_medium_eet7y_114", H = "_small_eet7y_122", e = {
  "ride-checkbox": "_ride-checkbox_eet7y_1",
  "input-container": "_input-container_eet7y_7",
  "checkbox-container": "_checkbox-container_eet7y_14",
  checkbox: C,
  input: v,
  glyph: G,
  error: z,
  "state-layer": "_state-layer_eet7y_84",
  disabled: I,
  "label-container": "_label-container_eet7y_87",
  "safe-zone": "_safe-zone_eet7y_114",
  medium: w,
  small: H
}, j = f(
  ({
    children: c,
    className: i,
    disabled: a,
    error: n,
    errorMessage: r,
    indeterminate: o,
    size: l = "medium",
    "aria-label": m,
    "data-testid": _,
    value: p,
    ...y
  }, d) => {
    const s = E(null), b = () => k(i, e["ride-checkbox"], e[l], {
      [e.error]: !a && n,
      [e.indeterminate]: o,
      [e.disabled]: a,
      [e["safe-zone"]]: !c
    }), h = () => {
      const u = o ? g : R;
      return /* @__PURE__ */ t.createElement(
        u,
        {
          className: e.glyph,
          fill: "currentColor",
          size: l
        }
      );
    };
    return N(d, () => s.current), /* @__PURE__ */ t.createElement("div", { "data-testid": _, className: b() }, /* @__PURE__ */ t.createElement("label", { className: e["input-container"] }, /* @__PURE__ */ t.createElement("div", { className: e["checkbox-container"] }, /* @__PURE__ */ t.createElement(
      "input",
      {
        ...y,
        className: e.input,
        disabled: a,
        ref: s,
        type: "checkbox",
        "aria-label": m,
        value: p
      }
    ), /* @__PURE__ */ t.createElement("span", { className: e.checkbox }, h()), /* @__PURE__ */ t.createElement("div", { className: e["state-layer"] })), c && /* @__PURE__ */ t.createElement("div", { className: e["label-container"] }, c)), !a && n && r && /* @__PURE__ */ t.createElement(x, { message: r }));
  }
);
j.displayName = "RideCheckbox";
export {
  j as RideCheckbox
};
